var map = {
	"./020-wow.svg": "2e60",
	"./021-sign language.svg": "754f",
	"./022-bathroom.svg": "cdde",
	"./024-maloik.svg": "e671",
	"./025-Farewell.svg": "61f2",
	"./026-come.svg": "96ae",
	"./027-what are you doing.svg": "a541",
	"./028-equality.svg": "be13",
	"./029-far.svg": "1c8b",
	"./030-like.svg": "0c59",
	"./031-ok.svg": "eb50",
	"./032-good.svg": "67ce",
	"./033-stop.svg": "43e2",
	"./035-hello.svg": "6aed",
	"./036-sign language.svg": "797c",
	"./037-i love you.svg": "90d4",
	"./038-i love you.svg": "c571",
	"./039-later.svg": "081a",
	"./040-lol.svg": "668e",
	"./041-No.svg": "bcd9",
	"./042-perfect.svg": "3e92",
	"./043-question.svg": "68ac",
	"./044-maloik.svg": "6b28",
	"./046-stare.svg": "a878",
	"./letter-a.svg": "0c57",
	"./letter-b.svg": "43f3",
	"./letter-c.svg": "76e5",
	"./letter-d.svg": "27fa",
	"./letter-e.svg": "e592",
	"./letter-f.svg": "6cdb",
	"./letter-g.svg": "016a",
	"./letter-h.svg": "73d6",
	"./letter-i.svg": "b9f7",
	"./letter-j.svg": "547c",
	"./letter-k.svg": "cddc",
	"./letter-l.svg": "7120",
	"./letter-m.svg": "f386",
	"./letter-n.svg": "3d22",
	"./letter-o.svg": "88b1",
	"./letter-p.svg": "e4fc",
	"./letter-q.svg": "3c4f",
	"./letter-r.svg": "cb40",
	"./letter-s.svg": "d4e6",
	"./letter-t.svg": "eaaf",
	"./letter-u.svg": "befb",
	"./letter-v.svg": "1cbc",
	"./letter-w.svg": "bfa1",
	"./letter-x.svg": "93aa",
	"./letter-y.svg": "fb95",
	"./letter-z.svg": "b4e5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7451";